import ChangeLog from "@/interfaces/Changelog";

const changelogs: ChangeLog[] = [
  {
    version: "0.9.1",
    title: "Formalys - Correction et ajustements",
    date: "08 Janvier 2024 - 15h00",
    logs: {
      Nouveautés: [
        "Ajout visuel des <code>salariés</code> dans les formations d'entreprise",
      ],
      Supperssions: ["Suppression des <code>statuts de rendez-vous</code>"],
      Modifications: ["<code>Système</code> de prise de rendez-vous"],
      Corrections: ["Correction de <code>bugs mineurs</code>."],
    },
  },
  {
    version: "0.9.0",
    title: "Formalys - Lancement du projet",
    date: "08 Janvier 2024",
    warning: {
      title: "Mise à jour importante",
      text: "Nous avons mis à jour le système de gestion des fiches pour les commerciaux et les télépros. Veuillez lire attentivement les changements ci-dessous.",
    },
    logs: {
      Nouveautés: [
        "Statuts de <code>rendez-vous</code>",
        "Ajout des <code>alias</code> pour les statuts",
        "Ajout de l'<code>avatar</code> pour les utilisateurs",
        "Ajout des <code>fichiers</code> pour les entreprises",
      ],
      Modifications: [
        "<code>Champs</code> pour la création d'une fiche de formation",
        "<code>Champs</code> pour la création d'une entreprise",
        "Amélioration du <code>calendrier</code> pour les rendez-vous",
      ],
      Corrections: ["Correction de <code>bugs mineurs</code>."],
    },
  },
];

export default changelogs;
